import { useLanguage } from "@/context/LanguageContext";

const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="language-toggle" data-testid="language-toggle">
      <button
        type="button"
        onClick={() => setLanguage("fr")}
        className={`language-button ${language === "fr" ? "active" : ""}`}
        data-testid="language-fr-button"
      >
        FR
      </button>
      <button
        type="button"
        onClick={() => setLanguage("en")}
        className={`language-button ${language === "en" ? "active" : ""}`}
        data-testid="language-en-button"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;